import axios from "@/libs/api.request";

/**
 * 获取广播数据
 */
export const getGradeBroad = ({status,appKey,grade})=>{
  const params = {status,appKey,grade}
  return axios.request({
    url:'system-service/api-v2.0/grade/broad',
    method:'get',
    params
  })
}

/**
 * 获取分机
 * @param appKey
 * @returns {*}
 */
export const getGradeExten = ({appKey,grade,detail})=>{
  const params = {appKey,grade,detail}
  return axios.request({
    url:'system-service/api-v2.0/grade/extens',
    method:'get',
    params
  })
}

/**
 * 获取级联树形分机
 * @param appKey
 * @param grade
 * @returns {*}
 */
export const getGradeTreeExtens = ({appKey,deptId}) => {
  const params = {appKey, deptId}
  return axios.request({
    url: 'system-service/api-v2.0/grade/dept/extens',
    method: 'get',
    params
  })
}

/**
 * 获取级联树形分机
 * @param appKey
 * @param grade
 * @returns {*}
 */
export const getGradeTreeDept = ({appKey}) => {
  const params = {appKey}
  return axios.request({
    url: 'system-service/api-v2.0/grade/tree/dept',
    method: 'get',
    params
  })
}

/**
 * 获取系统的级联架构
 * @returns {*}
 */
export const systemCascadeTree = () =>{
  return axios.request({
    url:'system-service/api-v2.0/grade/tree',
    method:'get',
  })
}

export const getGradeUrl = ({appKey, from, lang}) => {
  const params = {appKey,from, lang}
  return axios.request({
    url: 'system-service/api-v2.0/grade/proxy',
    method:'get',
    params
  })

}
//获取同级级联系统数据
export const getGradeSystemInfo = () => {
  return axios.request({
    url: 'system-service/api-v2.0/grade/linksys/query',
    method:'get',
  })

}




// WEBPACK FOOTER //
// ./src/api/cascade.js